/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import AccountService from 'cio/services/account';
import { InlineSupportPageArgs } from 'cio/components/inline-support';

export default class SubjectPage extends Component<InlineSupportPageArgs> {
  @service account!: AccountService;
  @service auth!: AuthService;
  @tracked isHarBannerVisible = true;

  constructor(owner: unknown, args: InlineSupportPageArgs) {
    super(owner, args);

    if (this.supportAccessAlreadyGranted) {
      this.args.trackEvent('inline_support_support_access_granted', { wasAlreadyGranted: true });
    }
  }

  @action
  closeHarBanner() {
    this.isHarBannerVisible = false;
  }

  @action
  handleEmailInput(value: string) {
    this.args.setFormValue('replyTo', value);
  }

  @action
  handleChangeAccessGrant(value: boolean) {
    this.args.setFormValue('supportAccess', value);
  }

  get supportAccessAlreadyGranted() {
    return this.account.current.supportTeamAccessEnabled;
  }

  get shouldDisplayAccessGrant() {
    return this.auth.hasPermission('account/support_access/edit') && !this.supportAccessAlreadyGranted;
  }

  @action
  didSelectFile(file: File & { source: string }) {
    let { attachments } = this.args.formValues;
    this.args.setFormValue('attachments', [...attachments, file]);
  }

  @action
  removeAttachment(index: number) {
    let { attachments } = this.args.formValues;
    this.args.setFormValue(
      'attachments',
      attachments.filter((_, i) => i !== index),
    );
  }
}
